import { useQuery } from "@tanstack/react-query";
import {
  getActiveCrawls,
  getUnacknowledgedChanges,
} from "../../api/monitoring";
import { useToolScope } from "../../features/toolExperience/useToolScope";
export function useMonitoringAttention() {
  const scope = useToolScope();
  const key = [scope?.userId, scope?.organizationId];
  const active = useQuery({
    queryKey: ["tool-experience", "active-crawls", ...key],
    queryFn: getActiveCrawls,
    enabled: !!scope,
    refetchInterval: 15_000,
  });
  const changes = useQuery({
    queryKey: ["tool-experience", "unacknowledged", ...key],
    queryFn: () => getUnacknowledgedChanges(50),
    enabled: !!scope,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
  return { active, changes };
}
